import React from 'react';
import Icon from 'eventbrite_design_system/icon/Icon';
import Link from 'eventbrite_design_system/link/Link';
import classNames from 'classnames';
import gettext from '@eb/gettext';

export const SectionGroup = ({ children, isFirst = false }) => {
    const sectionClassName = classNames(
        {
            'eds-l-mar-top-10': !isFirst,
        },
        'eds-g-group',
        'eds-l-mar-bot-8',
    );

    return <div className={sectionClassName}>{children}</div>;
};

export const SectionHeader = ({ title }) => (
    <h1 className="eds-text-hm eds-text-color--grey-900">{title}</h1>
);

export const SectionDescription = ({
    title,
    text,
    learnMoreUrl,
    onLearnMoreClicked,
}) => {
    let learnMoreLink;

    // Optional "Learn more" link
    if (learnMoreUrl && onLearnMoreClicked) {
        learnMoreLink = (
            <span className="learn-more-container eds-l-pad-left-2">
                <Link
                    to={learnMoreUrl}
                    onClick={onLearnMoreClicked}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {gettext('Learn more')}
                </Link>
            </span>
        );
    }
    return (
        <div>
            <SectionHeader title={title} />
            <div className="eds-g-cell eds-g-cell-1-1 eds-g-cell-lw-9-12 eds-g-cell-lg-9-12 eds-g-cell-ln-9-12 eds-g-cell-mw-9-12 eds-g-cell-md-1-1 eds-g-cell-mn-9-12 eds-g-cell-sw-9-12">
                <p className="eds-text-bm eds-text-color--grey-800">
                    <span>{text}</span>
                    {learnMoreLink}
                </p>
            </div>
        </div>
    );
};

export const SectionIcon = ({ icon }) => (
    <div className="eds-g-cell eds-vertical-group eds-g-cell-1-12 eds-g-offset-1-12 eds-show-up-md eds-l-pad-top-1">
        <Icon type={icon} size="medium" color="grey-300" />
    </div>
);

export const SectionForm = ({ children }) => (
    <div className="eds-g-cell eds-vertical-group eds-g-cell-12-12 eds-g-cell-sw-10-12 eds-g-cell-lw-9-12 eds-g-cell-lg-8-12 eds-g-cell-ln-8-12 eds-g-cell-md-8-12 eds-g-offset-sw-1-12 eds-g-offset-md-0-12 eds-g-cell--has-overflow">
        {children}
    </div>
);
